let isPlaying = false;
let ctx;
let osc;
let interval;

export const startSiren = () => {
  if (isPlaying) return;
  isPlaying = true;
  
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext) return;
  
  try {
    ctx = new AudioContext();
    osc = ctx.createOscillator();
    const gain = ctx.createGain();
    
    osc.connect(gain);
    gain.connect(ctx.destination);
    
    osc.type = 'square'; // Harsh, loud sound
    gain.gain.value = 0.3; // Moderate volume
    
    let high = true;
    osc.frequency.setValueAtTime(800, ctx.currentTime);
    
    interval = setInterval(() => {
      if (!ctx || ctx.state === 'closed') return;
      if (high) {
        osc.frequency.setValueAtTime(400, ctx.currentTime);
      } else {
        osc.frequency.setValueAtTime(800, ctx.currentTime);
      }
      high = !high;
    }, 400); // 400ms interval for siren
    
    osc.start();
  } catch (error) {
    console.error("Audio playback failed", error);
    isPlaying = false;
  }
};

export const stopSiren = () => {
  if (!isPlaying) return;
  isPlaying = false;
  clearInterval(interval);
  if (osc) {
    try { osc.stop(); } catch(e){}
  }
  if (ctx) {
    try { ctx.close(); } catch(e){}
  }
};
